import { ChartBarIcon } from "@heroicons/react/24/solid";

export function EmptyState() {
  return (
    <div className="bg-gray-50 mt-4 flex h-44 items-center justify-center rounded-md border border-gray-300 border-dashed p-4">
      <div className="text-center">
        <ChartBarIcon
          className="mx-auto h-7 w-7 text-gray-300"
          aria-hidden={true}
        />
        <p className="mt-2 text-gray-800 font-medium">No data to show</p>
        <p className="text-gray-700">There are no data available</p>
      </div>
    </div>
  );
}
